/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';


export const baby_misc : {[key: string]: Array<[string, string]>} = {
};
